// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"db0287ec","322":"02b2c988","433":"40145925","529":"8b0149db","988":"e50fdf84"}[chunkId] + ".chunk.js";
};